import { Context, createContext } from 'react';

export type TComponentsConfigValues = Record<string, any>;

const ComponentsConfigContext: Context<TComponentsConfigValues> = createContext(
  {}
);

export default ComponentsConfigContext;
